import { HrefLink } from '@smartbear/swagger-portal-component-library'
import { useTranslation } from 'react-i18next'

import sharedDefaults from '~/shared/shared.defaults.json'

export const NetworkErrorNotification = ({ 
  status, 
  statusText, 
  errorId,
}: { 
  status: number, 
  statusText?: string, 
  errorId: string,
}) => {
  const { t } = useTranslation()
  const supportRequest = sharedDefaults.support.supportRequest
  return (
    <div>
      <p className="mb-1.5 font-semibold text-md max-h-[16.25rem] overflow-auto">
        {status} {statusText || t(`errors.status.${status}`)}
      </p>
      <p className="mb-1.5 text-body2 font-semibold">{t('errors.report.message', { id: errorId })}</p>
      <HrefLink className="font-semibold text-body2" href={supportRequest} label={t('errors.report.button.label')} size="small" isExternal={true} target="_blank" />
    </div>
  )
}